import { useNavigate } from 'react-router-dom';

import { useUser, clearUserFromCookie } from '../../hooks/useUser';
import { Message } from '../index';
import { NotificationBell } from '../Notification';

import { employeeLogout } from '../../service/api/Employee/apiEmployee';

const Header = () => {
    const navigate = useNavigate();
    const { token, name, isLoggedIn } = useUser();

    const handleLogout = async () => {
        try {
            if (token) {
                await employeeLogout(token);
            }

            // 清除所有用戶信息
            clearUserFromCookie();

            Message('登出成功');
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
            Message('登出失敗', 'warning');
        }
    };

    const handleLogin = () => {
        navigate('/login');
    };

    return (
        <>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a className="navbar-brand ps-3" href="Home">家具公車</a>
                <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" href="#!"><i className="fas fa-bars"></i></button>
                <form className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
                    <div className="input-group">
                        <input className="form-control" type="text" placeholder="Search for..." aria-label="Search for..." aria-describedby="btnNavbarSearch" />
                        <button className="btn btn-primary" id="btnNavbarSearch" type="button"><i className="fas fa-search"></i></button>
                    </div>
                </form>
                <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">

                    {isLoggedIn ? (
                        // 已登入 - 顯示用戶名和登出選項
                        <li className="nav-item dropdown">
                            <button className="nav-link dropdown-toggle btn btn-link" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ border: 'none', background: 'none', padding: '0.5rem 1rem' }}>
                                <i className="fas fa-user fa-fw"></i>
                                {name && <span className="ms-2">{name}</span>}
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item" href="/SKAManager/SetOrderRule">設定</a></li>
                                {/* <li><a className="dropdown-item" href="#!">Activity Log</a></li> */}
                                <li><hr className="dropdown-divider" /></li>
                                <li><a className="dropdown-item" href="#!" onClick={handleLogout}>登出</a></li>
                            </ul>
                        </li>
                    ) : (
                        // 未登入 - 顯示登入按鈕
                        <li className="nav-item">
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={handleLogin}
                                style={{ marginRight: '10px' }}
                            >
                                <i className="fas fa-sign-in-alt"></i> 登入
                            </button>
                        </li>
                    )}

                    {isLoggedIn && <NotificationBell />}
                </ul>
            </nav>
        </>
    )
}
export { Header }